import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueExportBlocked: {
		id: 'issue-view-foundation.issue-actions.issue-export-blocked-footer-group.export-blocked-info.issue-export-blocked',
		defaultMessage: "Export is blocked by your organization's security policy.",
		description: 'Issue Export Blocked Message',
	},
});
